
import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Container, Stack, Grid } from "@mui/material";
import downloadPhoneImage from "../../../../../Assets/downloadPhoneImage.png"; // Ensure this is the correct path
import downloadPlaystore from "../../../../../Assets/Google play.svg"; // Ensure this is the correct path
import downloadAppstore from "../../../../../Assets/App Store.svg"; // Ensure this is the correct path
import { useDispatch, useSelector } from "react-redux";

import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const DownloadPhone = ({ referralsDates, values, onClose ,sectionNameForApproveAndReject}) => {



    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getHomeSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETHOMESECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Home section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);


    return (
        <Box>
            <Box
                sx={{
                    position: "relative",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    padding: { xs: "30px 0px 10px 0", md: "50px 0px" }
                }}
            >
                <Container maxWidth="lg" sx={{ zIndex: 2 }}>
                    <Grid
                        container
                        xs={12}
                    >


                        {/* Left Section */}
                        <Grid
                            item
                            md={8}
                            sx={{ color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Box>
                                <Typography
                                    variant="h1"
                                    textAlign="start"
                                    sx={{
                                        fontSize: { xs: "30px", md: "40px" },

                                        // maxWidth: "600px",
                                        color: "#3B4056",
                                        mb: 1,

                                    }}
                                >
                                    {responseData?.heading || values?.title || "Default Sub-heading"}
                                    {/* Download our mobile app & Earn Gold Anywhere Anytime */}

                                </Typography>


                                <Typography
                                    variant="body1"
                                    textAlign="start"
                                    sx={{
                                        mt: 2,

                                        mb: 3,
                                        lineHeight: "1.6",
                                        color: "#7A7A7A",
                                        maxWidth: "600px",
                                        fontSize: "14px",
                                        letterSpacing: "0px",
                                        opacity: 1,
                                    }}
                                >
                                    {responseData?.content || values?.content || "Default Sub-heading"}
                                    {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown */}

                                </Typography>
                                {/* <Grid container spacing={2}>
                                <Box
                                    component="img"
                                    src={downloadPlaystore}
                                    sx={{
                                        height: { xs: "30px", md: "50px" },
                                        width: { xs: "200px", md: "300px" }

                                    }}
                                >

                                </Box>
                                <Box
                                    component="img"
                                    src={downloadAppstore}
                                    sx={{
                                        height: { xs: "30px", md: "50px" },
                                        width: { xs: "200px", md: "300px" }

                                    }}
                                >

                                </Box>

                            </Grid> */}
                                <Box sx={{ display: "flex" }}>
                                    <Grid item >
                                        <Box
                                            component="img"
                                            src={downloadPlaystore}
                                            sx={{
                                                height: { xs: "30px", md: "50px" },
                                                width: { xs: "150px", md: "200px" }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Box
                                            component="img"
                                            src={downloadAppstore}
                                            sx={{
                                                height: { xs: "30px", md: "50px" },
                                                width: { xs: "150px", md: "200px" }
                                            }}
                                        />
                                    </Grid>
                                </Box>





                            </Box>
                        </Grid>
                        {/* Right Section: Image */}
                        <Grid
                            item
                            md={4}
                            sx={{
                                display: "flex", // Flexbox to apply justifyContent and alignItems
                                justifyContent: "center", // Center horizontally
                                alignItems: "center", // Center vertically

                                position: "relative", // Needed for z-index control
                                zIndex: 0, // Keep it behind other elements
                                display: {
                                    xs: "none", // Hide on extra small screens
                                    sm: "flex", // Show on small screens and above
                                },
                            }}
                        >
                            <img src={`${adminUrl}${values?.image || responseData?.additional_data[0]?.banner}`} alt="Refer" style={{ height: "300px", width: "150px", zIndex: 1, position: "relative" }} />
                        </Grid>

                    </Grid>
                </Container>
            </Box >
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject}/>
        </Box>
    );
};

export default DownloadPhone;
